// import React from 'react';
// import * as FileSaver from 'file-saver';
// import XLSX from 'sheetjs-style';
// import DownloadIcon from '@mui/icons-material/Download';
 
 
// function DownloadExcel({excelData,fileName, buttonText}){
 
//     const fileType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     const fileExtension='.xlsx';
//     const exportToExcel= async(fileName)=>{
//         const ws= XLSX.utils.json_to_sheet(excelData);
//         const wb= {Sheets: {'data':ws}, SheetNames:['data']};
//         const excelBuffer = XLSX.write(wb, {bookType:'xlsx', type:'array'});
//         const data= new Blob([excelBuffer], {type:fileType});
//         FileSaver.saveAs(data, fileName+fileExtension);
//     }
//     return(
//          <button type="button" className="btn btn-primary  mx-2" onClick={(e)=> exportToExcel(fileName)}><DownloadIcon/>{buttonText}</button>
//     )
// }
//  export default DownloadExcel;

// import React from 'react';
// import * as FileSaver from 'file-saver';
// import XLSX from 'sheetjs-style';
// // import DownloadIcon from '@mui/icons-material/Download';
// import { Download,  } from "react-bootstrap-icons";
 

// interface DownloadExcelProps {
//     excelData: any[];  
//     fileName: string;
//     buttonText: string;
// }
 
// const DownloadExcel: React.FC<DownloadExcelProps> = ({ excelData, fileName, buttonText }) => {
//     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     const fileExtension = '.xlsx';

//     const exportToExcel = async (fileName: string) => {
//         const ws = XLSX.utils.json_to_sheet(excelData);
//         const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//         const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//         const data = new Blob([excelBuffer], { type: fileType });
//         FileSaver.saveAs(data, fileName + fileExtension);
//     };

//     return (
//         <button type="button" className="btn btn-warning mx-2" onClick={() => exportToExcel(fileName)}><Download/>
//             {buttonText}
//         </button>
//     );
// };

// export default DownloadExcel;

import React, { forwardRef, useImperativeHandle } from 'react';
import * as FileSaver from 'file-saver';
// import XLSX from 'sheetjs-style';
import XLSX from 'sheetjs-style'
// import { Download } from "react-bootstrap-icons";


interface DownloadExcelProps {
    excelData: any[];
    fileName: string;
    buttonText: string;
}

const DownloadExcel = forwardRef<any, DownloadExcelProps>(({ excelData, fileName, buttonText }, ref) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel = async (fileName: string) => {
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    useImperativeHandle(ref, () => ({
        exportToExcel,
    }));

    return null; // Remove the button rendering here
});

export default DownloadExcel;